// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"423ec1a8","100":"53a7506f","122":"69eaedf1","140":"2ff21824","427":"f0f4e001","499":"71820bcd"}[chunkId] + ".chunk.js";
};